<template>
  <el-dialog
    class="dialog-form"
    append-to-body
    :visible.sync="visibleItem"
    title="Thêm nhanh sản phẩm"
    width="600px"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :before-close="closePopup"
  >
    <validation-observer ref="observerItem" id="observerItem">
      <form>
        <LayoutFieldSet type="block" >
          <LayoutField type="block" :required="true">
            <template #label>Tên sản phẩm </template>
            <template #input>
              <BaseInput
                placeholder="Nhập tên sản phẩm"
                v-model="Item.name"
                name="Tên sản phẩm"
                :rules="'required|lBetween:3,255|CHECK_HTML'"
              />
            </template>
          </LayoutField>

          <LayoutField type="block">
            <template #label>Mã SKU</template>
            <template #input>
              <BaseInput
                placeholder="Nhập mã SKU"
                v-model="Item.sku"
                type="SKU_UPC"
                :rules="'SKU|lBetween:1,16'"
                :validate="Item.validate.sku"
                @blur="checkDublicate(Item.sku)"
              />
            </template>
          </LayoutField>
        </LayoutFieldSet>

        <LayoutFieldSet type="block">
          <LayoutField type="block">
            <template #label>Danh mục</template>
            <template #input>
              <BaseSelect
                :options="categories"
                label="name"
                placeholder="Chọn danh mục"
                v-model="Item.metaSearchable.category"
                @select="getListCategorySub($event)"
              />
            </template>
          </LayoutField>

          <LayoutField type="block" >
            <template #label>Loại sản phẩm</template>
            <template #input>
              <BaseSelect
                v-model="Item.categorySub"
                :options="categorySub"
                :label="'name'"
                placeholder="Chọn loại sản phẩm"
                @select="getValueCategorySub($event)"
              />
            </template>
          </LayoutField>
        </LayoutFieldSet>

        <LayoutFieldSet>
          <LayoutField  type="block">
            <template #label> Đơn vị tính</template>
            <template #input>
              <BaseSelect
                :options="units"
                :label="'unitName'"
                :placeholder="'Chọn đơn vị tính'"
                v-model="Item.unit.name"
              />
            </template>
          </LayoutField>
        </LayoutFieldSet>

        <LayoutFieldSet type="block">
          <LayoutField type="block" >
            <template #label>Giá nhập</template>
            <template #input>
              <BaseInput 
                v-model="Item.priceItem.importPrice" 
                type="money" 
              />
            </template>
          </LayoutField>

          <LayoutField type="block">
            <template #label>Giá bán</template>
            <template #input>
              <BaseInput 
                v-model="Item.priceItem.exportPrice" 
                type="money" 
              />
            </template>
          </LayoutField>
        </LayoutFieldSet>
      </form>
    </validation-observer>

    <template slot="footer">
      <el-button type="text" @click="closePopup()"> Thoát </el-button>
      <el-button
        :loading="btnLoading"
        type="primary"
        @click="btnConfirmAddItem()"
      >
        Hoàn tất
      </el-button>
    </template>
  </el-dialog>
</template>

<script>
import getListUnit from "@/mixins/items/getListUnit";
import getListCategory from "@/mixins/items/getListCategory";
import handlerReqCreatItem from "@/mixins/items/handlerReqCreatItem";

import { CategoryService } from "@/services/nextshop/category.service";
import { ProductService } from "@/services/nextshop/product.service";

export default {
  props: {
    isPopup: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      btnLoading: false,
      visibleItem: false,
      categorySub: [],
      categories: [],
      units: [],
      Item: {
        name: "",
        sku: "",
        validate: {
          sku: ''
        },
        metaSearchable: {
          category: "",
        },
        categoryId: "",
        categorySub: "",
        unit: {
          name: "",
        },
        priceItem: {
          importPrice: 0,
          exportPrice: 0,
        },
      },
    };
  },

  mixins: [
    handlerReqCreatItem,
    getListCategory,
    getListUnit
  ],

  async created() {
    try {
      this.categories = await this.getListCategory();
      this.units = await this.getListUnit();
    } catch (error) {
      this.$message.error(error);
    }
  },

  methods: {
    async btnConfirmAddItem() {
      try {
        await this.$refs.observerItem.validate();
        await this.sleep(500)

        let el = document.querySelector("#observerItem .is-invalid");
        if (el) {
          el.scrollIntoView({
            behavior: "smooth",
            block: "center",
          });
          el.focus();
        } else {
          this.btnLoading = true;
          const req = await this.handlerReqCreatItem(this.Item, []);
          await ProductService.createItem(req).then(async (res) => {
            console.log(res);
            await this.sleep(1000);
            if (res.success) {
              this.btnLoading = false;
              this.Item = {
                name: "",
                sku: "",
                validate: {
                  category: '',
                  categorySub: '',
                  sku: ''
                },
                metaSearchable: { category: "" },
                categoryId: "",
                categorySub: "",
                unit: { name: "" },
                priceItem: {
                  importPrice: 0,
                  exportPrice: 0,
                },
              }
              this.$emit('getValue', res.data)
            }
          });
        }
      } catch (error) {
        console.log(error);
        this.$message.error(error);
        this.btnLoading = false;
      }
    },

    async getListCategorySub(value) {
      try {
        this.Item.metaSearchable.category = value.text;
        this.Item.categorySub = "";
        this.Item.categoryId = "";
        this.categorySub = [];
        if (value.text != "") {
          const params = {
            queryString: { parentId: { eq: value.id } },
            sort: "-id",
            lastItem: "",
            limit: 100,
          };
          const response = await CategoryService.getList(params);
          if (response.success) {
            this.categorySub = response.data;
          }
        }
      } catch (error) {
        console.log(error);
      }
    },

    getValueCategorySub($event) {
      if ($event.text != "") {
        this.Item.categoryId = $event.id;
        this.Item.categorySub = $event.text;
      } else {
        this.Item.categorySub = "";
      }
    },

    async checkDublicate(value) {
      try {
        const params = {
          pagingAndSorting: { limit: 10, lastIndex: "", sortOrder: "DESC" },
          queryString:
            "{variations.sku}=='''" + `${value}` + "'''",
        };

        const response =
          value != "" ? await ProductService.getList(params) : { data: [] };

        if (response.data.length > 0) {
          this.Item.validate.sku = 'Mã SKU đã tồn tại'
        } else {
          this.Item.validate.sku = ''
        }
      } catch (error) {
        console.log(error);
      }
    },

    closePopup() {
      this.visibleItem = false;
      this.$emit("getValue", null);
    },
  },

  watch: {
    isPopup: {
      handler: function () {
        this.visibleItem = this.isPopup;
      },
    },
  },
};
</script>

<style>
</style>